import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { pageGoodsComments } from '../../api/goodsComment';

// 分页查询商品评论的异步 thunk
export const fetchGoodsComments = createAsyncThunk(
  'goodsComment/fetchGoodsComments',
  async ({ page = 1, pageSize = 10, queryParams = {} }, { rejectWithValue }) => {
    try {
      const response = await pageGoodsComments(page, pageSize, queryParams);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const goodsCommentSlice = createSlice({
  name: 'goodsComment',
  initialState: {
    comments: [],
    total: 0,
    page: 1,
    pageSize: 10,
    loading: false,
    error: null,
    currentComment: null
  },
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setCurrentGoodsComment: (state, action) => {
      state.currentComment = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGoodsComments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGoodsComments.fulfilled, (state, action) => {
        state.loading = false;
        state.comments = action.payload.records;
        state.total = action.payload.total;
        state.page = action.payload.current;
        state.pageSize = action.payload.size;
      })
      .addCase(fetchGoodsComments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { 
  setPage, 
  setPageSize, 
  setCurrentGoodsComment 
} = goodsCommentSlice.actions;

export default goodsCommentSlice.reducer;

